module.exports = __webpack_public_path__ + "img/tour-19.43da6eb5.png";